export default "__VITE_ASSET__CrzdPi4N__"